<template>
  <div class="flex flex-col gap-6 w-full">
    <div class="flex flex-col w-full gap-3 items-start">
      <p class="text-xs font-medium text-white">Today</p>
      <ActivityListItem
        v-for="item in activityList"
        :key="item"
        :data="item"
        @open-activity-detail="openActivityDetailDrawer"
      ></ActivityListItem>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import ActivityListItem from '../ActivityListItem.vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import ActivityDrawer from '../drawers/ActivityDrawer.vue'

const activityList = ref([
  {
    title: 'Account Created',
    subtitle: 'Captain: ',
    type: 'create',
    currency: '5000'
  },
])

const activityList2 = ref([
  {
    title: 'Ship : Crew upgraded',
    subtitle: 'Vice Captain: ',
    type: 'upgrade',
    currency: '1000'
  },
  {
    title: 'Unlock new ship : crew',
    subtitle: 'Vice Captain: ',
    type: 'unlock',
    currency: '1000'
  },
  {
    title: 'Buy Skin “Sowrds Tridient” Sucessed',
    subtitle: 'Buy Skin ',
    type: 'buy',
    currency: '1000'
  },
  {
    title: 'You Have  “Watch youtube videos” Complete',
    subtitle: 'Rewards Claimed',
    type: 'completed',
    currency: '1000'
  },
  {
    title: 'You Get New NFT “Ghozali_Ghozalu #631”',
    subtitle: 'Rewards Claimed',
    type: 'nft-buy',
    currency: '1000'
  },
  {
    title: 'New Character Can Be Used',
    subtitle: 'Quartermaster Bones unlocked',
    type: 'unlock',
    currency: '500,000'
  }
])

const openActivityDetailDrawer = (detailItem) => {
  openBottomDrawer(ActivityDrawer, {
    props: {
      data: detailItem
    },
    size: 'sm'
  })
}
</script>
